export const asyncStatus = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  ERROR: "error",
};

export const type_constant = {
  LOGIN: "LOGIN",
  CHECK_AUTH: "CHECK_AUTH",

  GET_ALL_STORES_ASYNC: "GET_ALL_STORES_ASYNC",
  UPDATE_STORE_STATUS_ASYNC: "UPDATE_STORE_STATUS_ASYNC",

  GET_ALL_Customers_ASYNC: "GET_ALL_Customers_ASYNC",
  UPDATE_Customer_STATUS_ASYNC: "UPDATE_Customer_STATUS_ASYNC",
  UPDATE_Customer_TAGS_ASYNC: "UPDATE_Customer_TAGS_ASYNC",

  GET_ALL_PRODUCTS_ASYNC: "GET_ALL_PRODUCTS_ASYNC",
  GET_PRODUCT_BY_ID_ASYNC: "GET_PRODUCT_BY_ID_ASYNC",
  UPDATE_PRODUCT_ASYNC: "UPDATE_PRODUCT_ASYNC",

  GET_ALL_ORDERS_ASYNC: "GET_ALL_ORDERS_ASYNC",
  GET_ORDER_BY_ID_ASYNC: "GET_ORDER_BY_ID_ASYNC",
  UPDATE_ORDER_STATUS_ASYNC: "UPDATE_ORDER_STATUS_ASYNC",

  GET_ALL_QUOTES_ASYNC: "GET_ALL_QUOTES_ASYNC",
  GET_QUOTE_BY_ID_ASYNC: "GET_QUOTE_BY_ID_ASYNC",
  UPDATE_QUOTE_STATUS_ASYNC: "UPDATE_QUOTE_STATUS_ASYNC",

  ADD_PRODUCT_ASYNC: "ADD_PRODUCT_ASYNC",
  MY_PRODUCT_DETAILS_ASYNC: "MY_PRODUCT_DETAILS_ASYNC",
  GET_ALL_VARIANTS: "GET_ALL_VARIANTS",
  GET_ALL_TYPES: "GET_ALL_TYPES",

  GET_REPORT_ASYNC: "GET_REPORT_ASYNC"
};

export const save_tokens_constant = {
  AUTH: "auth",
};
